// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"2454ff56ae10423e015d","92":"27db0fd035bb88f0745b","777":"7f73b0ee6412f4355feb"}[chunkId] + ".js";
};